
import React from 'react';
import './Footer.scss';
import parksLogo from "../../../assets/arrowhead-logo.svg";
import edsLogo from "../../../assets/eds.png";


const Footer = () => (
    <footer className="footer">
        <div id="footer">

            <div id="first"> <img src={edsLogo} alt="nps logo" height={25} margin-top={50} />
                &nbsp; ENTERPRISE DEVELOPMENT SERVICES™</div>
            <div id="second"><a href="https://www.nps.gov/aboutus/accessibility.htm" target="_blank">ACCESSIBILITY</a>
                &nbsp; | &nbsp;<a href="https://www.nps.gov/aboutus/privacy.htm" target="_blank"> PRIVACY
                    POLICY &nbsp;</a>
                | &nbsp;<a href="https://www.nps.gov/aboutus/foia/index.htm" target="_blank"> FOIA &nbsp;</a>
                | &nbsp;<a href="https://www.nps.gov/aboutus/notices.htm" target="_blank"> NOTICES</a>
                &nbsp; | &nbsp; <a href="https://www.nps.gov/aboutus/disclaimer.htm"
                                   target="_blank"> DISCLAIMER &nbsp;</a>
                |<a href="https://www.nps.gov/aboutus/faqs.htm" target="_blank"> &nbsp;FAQ </a>&nbsp; | &nbsp;<a
                    href="https://www.doi.gov/pmb/eeo/reports-repository" target="_blank"> &nbsp; NO FEAR
                    ACT </a>&nbsp; | &nbsp;<a href="https://www.nps.gov/aboutus/contactus.htm" target="_blank"> CONTACT
                    ACT </a>&nbsp; |
                <a href="https://www.usa.gov/" target="_blank">&nbsp; USA.GOV</a>
            </div>
            <div id="fourth">
                National Park Service <br></br>
                U.S. Department of the Interior
            </div>
            <div id="third">
                <img src={parksLogo} alt="nps logo" height={30} />


            </div>

        </div>

    </footer>
);

export default Footer;